import { styled } from '@mui/material'

export const Wrapper = styled('div')(({ theme }) => ({
  height: '100%',
  '.rbc-event': {
    backgroundColor: theme.palette.primary.main
  },
  '.rbc-event.rbc-selected': {
    backgroundColor: theme.palette.primary.main
  },
  marginBottom: '35px',

  // No mobile o modal e curto: sem altura minima por linha, o react-big-calendar
  // encolhia cada semana pra ~24px (a altura do numero do dia) e o chip do valor
  // era clipado — sobrava so um fiapo verde. Aqui a grade cresce ate caber o chip
  // e quem rola e o ModalContent.
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    '.rbc-month-view': {
      flex: 'none'
    },
    '.rbc-month-row': {
      minHeight: 46
    },
    '.rbc-row-segment': {
      padding: '0 2px'
    },
    '.rbc-event': {
      padding: '1px 3px'
    },
    '.rbc-date-cell': {
      fontSize: 12,
      paddingRight: 4
    },
    '.rbc-header': {
      fontSize: 11
    }
  }
}))
